// extracted by mini-css-extract-plugin
module.exports = {"cell":"NumberCell_cell__2o3mX"};